import { CatalogItemType } from '@pushly/models/lib/enums'
import { DomainDto } from '../../../dtos/domain'

/**
 * Returns the default catalog item type for the domain.
 * Falls back to Product when domain.ecommConfig.itemType is undefined.
 */
export function getDefaultCatalogItemType(domain: DomainDto | undefined): CatalogItemType {
    return domain?.ecommConfig?.itemType ?? CatalogItemType.PRODUCT
}

/**
 * Returns the default max abandoned item age (in days) for the domain.
 * Falls back to 30 when domain.ecommConfig.maxAbandonedItemAgeDays is undefined.
 *
 * The 30 mirrors the backend DomainEcommConfig default. When a domain has no stored
 * max_abandoned_item_age_days, the evaluation engines fall back to that same 30, so this
 * value must not be changed to match whatever the domain editor happens to seed for new
 * configs — doing so makes the builder claim an age cutoff the engines do not apply.
 */
export function getDefaultMaxAbandonedItemAgeDays(domain: DomainDto | undefined): number {
    return domain?.ecommConfig?.maxAbandonedItemAgeDays ?? 30
}
